import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { useGetLocalizedValue } from '@/shared/lib/hooks/useGetLocalizedValue';
import { Badge } from '@/shared/ui/badge';
import './tags.scss';
import { TagsT } from './types';

type Props = Omit<ComponentPropsWithoutRef<'div'>, 'children'> & {
    tags?: TagsT;
    appearance?: ComponentPropsWithoutRef<typeof Badge>['appearance'];
};
export const Tags = ({ tags, appearance, className, ...props }: Props) => {
    const getLocalizedValue = useGetLocalizedValue();
    if (!tags || !tags.length) {
        return null;
    }

    return (
        <div className={cn('tags', className)} data-testid="tags" {...props}>
            {tags.map(({ icon: Icon, label, variant, customColor }, index) => (
                <Badge
                    asChild
                    key={index}
                    variant={variant}
                    customColor={customColor}
                    appearance={appearance}
                    data-testid="tag"
                >
                    <div>
                        {Icon && <Icon />}
                        <span>{getLocalizedValue(label)}</span>
                    </div>
                </Badge>
            ))}
        </div>
    );
};
